<script setup lang="ts">
import type { LastTuitionPolicyFragmentFragment } from '~/graphql/mma/generated/graphql';
import { mapTuitionImportMembershipStatus } from '~/utils/tuitionImportMembershipStatus';

const props = defineProps<{
  policy: LastTuitionPolicyFragmentFragment;
  routeName: string;
  uuid: string;
}>();

const lastPolicyLinks = computed(() => {
  const links: Array<{
    name: string;
    url: string;
    status: ReturnType<typeof mapTuitionImportMembershipStatus>;
    startDate: string;
    endDate: string;
  }> = [];

  if (props.policy?.faber) {
    const lastTuitionPolicy = props.policy.faber;
    links.push({
      name: lastTuitionPolicy.policy_number,
      url: `/${props.uuid}/tuition/${lastTuitionPolicy.policy_number}`,
      status: lastTuitionPolicy.policy_status,
      startDate: lastTuitionPolicy.start_date,
      endDate: lastTuitionPolicy.end_date,
    });
  }
  if (props.policy?.import) {
    const lastTuitionPolicy = props.policy.import;
    links.push({
      name: lastTuitionPolicy.policy_number,
      url: `/${props.uuid}/tuition/${lastTuitionPolicy.policy_number}`,
      status: mapTuitionImportMembershipStatus(lastTuitionPolicy.membership_status),
      startDate: lastTuitionPolicy.start_date ?? '',
      endDate: lastTuitionPolicy.end_date ?? '',
    });
  }
  return links;
});
</script>

<template>
  <MenuPolicyNames
    v-if="lastPolicyLinks.length > 0"
    title="Tuition policies"
    :links="lastPolicyLinks"
    :icon="['fal', 'building-columns']"
    :is-selected="routeName === 'uuid-tuition-policyNumber'"
  >
    <template #link-name="tuitionPolicy">
      <UiTuitionSummarySmall
        :policy="{
          policyNumber: tuitionPolicy.name,
          startDate: tuitionPolicy.startDate,
          endDate: tuitionPolicy.endDate,
          status: tuitionPolicy.status,
        }"
      />
    </template>
  </MenuPolicyNames>
</template>
